import { FC, useState } from 'react';
import { MainLayout } from '../MainLayout';
import { Button } from '@/components/ui/button';
import { useParams } from 'react-router-dom';
import { trpc } from 'src/trpc';
import { Loader } from 'src/components/Loader';
import { Notes } from 'src/components/Notes';
import { TruckDetailsForm } from './TruckDetailsForm';
import { QRCode } from 'src/components/QRCode';
import { useToast } from 'src/components/useToast';

export const TruckDetailsPage: FC = () => {
  const [isFormValid, setIsFormValid] = useState(false);
  const params = useParams<{ id: string }>();
  const { data, isLoading } = trpc.admin.truck.getTruck.useQuery(params.id!);
  const { successToast, errorToast } = useToast();

  const handleSuccess = () => {
    successToast({
      title: 'Truck updated',
      description: 'Truck details have been successfully updated',
    });
  };

  const handleError = (error: Error) => {
    errorToast({
      title: 'Failed to update truck',
      description: error.message || 'An error occurred while updating the truck details',
    });
  };

  if (isLoading || !data) {
    return (
      <MainLayout>
        <Loader title="Getting trucks" />
      </MainLayout>
    );
  }
  return (
    <MainLayout title="Trucks">
      <div className="flex flex-row gap-10">
        <div className="w-1/2 bg-white p-6 gap-2">
          <QRCode
            className="mb-4"
            qrCodeImageUrl={data.qrCodeUrl}
            entityId={data!.friendlyId}
            entityType="Truck"
          />
          <TruckDetailsForm
            truck={data}
            onSuccess={handleSuccess}
            onError={handleError}
            onStateChange={(state) => setIsFormValid(state.isValid)}
          >
            <div className="flex flex-row justify-start gap-4">
              <div>
                <Button disabled={!isFormValid} className="w-full text-white" type="submit">
                  Save Changes
                </Button>
              </div>
            </div>
          </TruckDetailsForm>
        </div>
        <div className="w-1/3">
          <Notes entityId={params.id!} origin="truck" />
        </div>
      </div>
    </MainLayout>
  );
};
